export default "__VITE_ASSET__f33f8da4__"